import { Button } from "@mui/material";

import { ClusterAgentStatus, type ClusterTableItem } from "./types";

interface ClusterActionProps {
  cluster: ClusterTableItem;
  onInstallAgent?: () => void;
  onManageAgent?: () => void;
}

const ClusterAction = ({ cluster, onInstallAgent, onManageAgent }: ClusterActionProps) => {
  if (cluster.agentStatus === ClusterAgentStatus.NEVER_TRANSMITTED) {
    return (
      <Button variant="text" onClick={onInstallAgent}>
        Install agent
      </Button>
    );
  }

  return (
    <Button variant="text" onClick={onManageAgent}>
      Manage agent
    </Button>
  );
};

export default ClusterAction;
